import { render } from "./OtpPhone.vue?vue&type=template&id=f492fed6&scoped=true"
import script from "./OtpPhone.vue?vue&type=script&lang=js"
export * from "./OtpPhone.vue?vue&type=script&lang=js"

import "./OtpPhone.vue?vue&type=style&index=0&id=f492fed6&scoped=true&lang=css"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f492fed6"]])

export default __exports__